import React from "react";
import { XIcon } from "staysure-component-library";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import RichText from "@/components/atoms/rich-text/rich-text";
import Styles from "@/components/molecules/policy-document-section/policy-document-section.module.css";

interface WithdrawalModalContentProps {
  modalTitle: string;
  modalContent: string;
  modalCloseButtonLabel: string;
  setIsOpen: (isOpen: boolean) => void;
}

function WithdrawalModalContent({
  modalTitle,
  modalContent,
  modalCloseButtonLabel,
  setIsOpen,
}: Readonly<WithdrawalModalContentProps>) {
  return (
    <div>
      <button
        id="withdrawal-modal-content-close-button"
        type="button"
        className="absolute right-4 top-4"
        onClick={() => {
          setIsOpen(false);
        }}
        aria-label="close modal"
      >
        <XIcon stroke="#306582" />
      </button>
      <div
        className="p-spacing-l md:p-spacing-xxxl flex-col"
        data-testid="withdrawal-modal-content-testid"
      >
        <div className="">
          <div className="mb-spacing-xs md:mb-spacing-s">
            <h1 className="font-header-font text-[23px] md:text-[31px] leading-[28px] md:leading-[34px] text-text-title">
              {modalTitle || "We are unable to proceed with your request"}
            </h1>
          </div>
          <div className="mb-spacing-l">
            <p className="font-body-font font-normal text-xs leading-[27px]">
              {modalContent && (
                <RichText
                  className={`${Styles.richtext}`}
                  richText={modalContent ?? ""}
                />
              )}
            </p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-center gap-2">
          <LabelButtonWrapper
            data-testid="withdrawal-modal-content-close-button"
            id="withdrawal-modal-content-close-button"
            label={modalCloseButtonLabel}
            hierarchy="secondary"
            type="button"
            onClick={() => {
              setIsOpen(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default WithdrawalModalContent;
